module.exports = __webpack_public_path__ + "img/2.6c1a7fe4.png";